import React, { useState, useContext, useEffect } from 'react';
import sortBy from 'lodash/sortBy';
import classNames from 'classnames';
import { defineMessages, useIntl } from 'react-intl';
import flatten from 'lodash/flatten';

import BundleProductCard from 'Features/Bundle/components/Cards/BundleProductCard';
import useViewport from 'Hooks/useViewport';
import PillFilters from 'Components/Utility/PillFilters';
import SelectedTierContext from 'Features/Bundle/context/selected-tier-context';


const messages = defineMessages({
  products: {
    id: 'BundleRedesignTieredProducts.products',
    defaultMessage: '{count} Products',
  },
  recommendedForYou: {
    id: 'BundleRedesignTieredProducts.recommendedForYou',
    defaultMessage: 'Recommended for you',
  },
});

const BundleRedesignTieredProducts = ({
  bundleTiers = [],
  switchCarouselGame = () => { },
  bundleSlug = '',
}) => {
  const { selectedTier, selectTier } = useContext(SelectedTierContext);
  const [currentTab, setCurrentTab] = useState(selectedTier || 0);
  const { formatMessage } = useIntl();
  const { isLg } = useViewport();

  useEffect(() => {
    if (selectedTier !== currentTab) {
      setCurrentTab(selectedTier);
    }
  }, [selectedTier, currentTab]);


  const tapOptions = bundleTiers.map((tier, index) => {
    const cumulativeCount = bundleTiers
      .slice(0, index + 1)
      .reduce((acc, currentTier) =>
        acc + (currentTier?.games?.filter(game => game.display).length || 0), 0); // Sum the counts

    return {
      name: formatMessage(messages.products, {
        count: cumulativeCount,
      }),
      type: index,
    };
  });

  const sortedBundleTiers = bundleTiers.slice(0, (currentTab + 1)).map(tier => ({
    games: sortBy(tier?.games?.filter(game => game.display), ['sort_order']),
  }));

  const flattenedBundleTiers = flatten(sortedBundleTiers.map(tier => tier?.games));

  const handleTabChange = (value) => {
    selectTier(value);
    setCurrentTab(value);
  };

  return (
    <div className="BundleRedesignTieredProducts">
      <div className="BundleRedesignTieredProducts__filters">
        <PillFilters
          mobilePills
          options={tapOptions}
          value={currentTab}
          onChange={handleTabChange}
        />
      </div>
      <section className="fan-grid-container">
        {flattenedBundleTiers.map((p, i) => {
          const index = i + 1;
          return (
            <div className={classNames({ 'two-column-row': isLg }, { 'three-column-row': !isLg })} key={p._id + index}>
              <BundleProductCard
                product={p}
                switchCarouselGame={switchCarouselGame}
                sizesOverride="(min-width: 1520px) 420px, (min-width: 1200px) 360px, (min-width: 992px) 300px, (min-width: 768px) 220px, (min-width: 576px) 255px, 50vw"
                bundleSlug={bundleSlug}
              />
            </div>
          );
        })}
      </section>
    </div>
  );
};

export default BundleRedesignTieredProducts;
